import { DATE_FORMAT_DAY_MONTH_YEAR } from '@constants/datetime';
import { formatDateTime } from '@utils/date-time-format/format-date-time';
import { fromBackend } from '@utils/map-date/from-backend';

export const formatResultDate = (timestamp: number | null, timezone: string | null, locale: string): string | null => {
  if (timestamp === null) return null;

  return formatDateTime({
    date: fromBackend(timestamp).toDate(),
    locale,
    format: DATE_FORMAT_DAY_MONTH_YEAR,
    timezone: timezone ?? undefined,
  });
};
